import {
    IconActivity,
    IconArrowDown,
    IconArrowLeft,
    IconArrowRight,
    IconCheckCircle,
    IconCheckSquare,
    IconChevronDown,
    IconClock,
    IconClose,
    IconCode,
    IconEdit,
    IconFacebook,
    IconFileCheck,
    IconFileText,
    IconFolder,
    IconFolderDown,
    IconGithub,
    IconGlobe,
    IconGrid,
    IconHelpCircle,
    IconInstagram,
    IconKey,
    IconLinkedin,
    IconLock,
    IconLogIn,
    IconMail,
    IconMastodon,
    IconMenu,
    IconMessage,
    IconMoon,
    IconPinterest,
    IconSearch,
    IconServer,
    IconShield,
    IconShieldCheck,
    IconSparkles,
    IconStar,
    IconSun,
    IconTag,
    IconTelegram,
    IconTiktok,
    IconUsers,
    IconWhatsapp,
    IconX,
    IconXCircle,
    IconXMark,
    IconYoutube,
} from '@/components/icons';

/**
 * Registry for UiIcon: maps a stored icon key (kebab-case; matches the Studio
 * icon pickers, see studio/constants/iconOptions.ts) to its component. Block
 * icons are feather/lucide-style strokes, social icons are simple-icons fills.
 * An unknown key renders nothing (see UiIcon).
 */
export const ICONS = {
    // Block icons (BLOCK_ICON_OPTIONS) — feather/lucide stroke set
    'file-check': IconFileCheck,
    'shield-check': IconShieldCheck,
    shield: IconShield,
    lock: IconLock,
    globe: IconGlobe,
    activity: IconActivity,
    clock: IconClock,
    search: IconSearch,
    users: IconUsers,
    tag: IconTag,
    'check-square': IconCheckSquare,
    'file-text': IconFileText,
    grid: IconGrid,
    folder: IconFolder,
    server: IconServer,
    key: IconKey,
    code: IconCode,
    message: IconMessage,
    edit: IconEdit,
    mail: IconMail,
    'folder-down': IconFolderDown,
    sparkles: IconSparkles,
    star: IconStar,
    'help-circle': IconHelpCircle,
    menu: IconMenu,

    // UI / navigational icons (used statically in the app)
    'chevron-down': IconChevronDown,
    'arrow-down': IconArrowDown,
    'arrow-left': IconArrowLeft,
    'arrow-right': IconArrowRight,
    close: IconClose,
    'x-mark': IconXMark,
    'x-circle': IconXCircle,
    'check-circle': IconCheckCircle,
    'log-in': IconLogIn,
    sun: IconSun,
    moon: IconMoon,

    // Social platforms (SOCIAL_ICON_OPTIONS) — simple-icons fill set
    instagram: IconInstagram,
    linkedin: IconLinkedin,
    x: IconX,
    facebook: IconFacebook,
    github: IconGithub,
    youtube: IconYoutube,
    tiktok: IconTiktok,
    pinterest: IconPinterest,
    whatsapp: IconWhatsapp,
    telegram: IconTelegram,
    mastodon: IconMastodon,
};

export type IconName = keyof typeof ICONS;

export function isIconName(value: unknown): value is IconName {
    return typeof value === 'string' && value in ICONS;
}
